import { call, put, fork, take } from '@redux-saga/core/effects'
import { createRoutine } from 'redux-saga-routines'
import * as guruChatService from 'services/GuruChatService'
import { getApiErrors } from 'utils/errors'
import { openWithEntity } from 'ducks/guruWidget/actions'

export const loadRecommendationsRoutine = createRoutine('GURU_RECOMMENDATIONS_LOAD')
export const dismissRecommendationRoutine = createRoutine('GURU_RECOMMENDATIONS_DISMISS')
export const executeEntityActionRoutine = createRoutine('GURU_ENTITY_ACTION_EXECUTE')

function* loadRecommendations({ payload }) {
  const { contextType, contextId, surface = 'widget', subSurface = null, entityType = null, entityId = null } = payload
  yield put(loadRecommendationsRoutine.request({ contextType, contextId }))

  try {
    const { data } = yield call(guruChatService.getRecommendations, { contextType, contextId, surface, subSurface, entityType, entityId })
    yield put(loadRecommendationsRoutine.success({ contextType, contextId, items: data.data || [] }))
  } catch (error) {
    yield put(loadRecommendationsRoutine.failure({ contextType, contextId, error: getApiErrors(error) }))
  } finally {
    yield put(loadRecommendationsRoutine.fulfill({ contextType, contextId }))
  }
}

function* dismissRecommendation({ payload }) {
  const { signature, scope, contextType, contextId } = payload
  yield put(dismissRecommendationRoutine.request({ signature }))

  try {
    yield call(guruChatService.dismissRecommendation, { signature, scope, contextType, contextId })
    yield put(dismissRecommendationRoutine.success({ signature, scope, contextType, contextId }))
  } catch (error) {
    yield put(dismissRecommendationRoutine.failure({ signature, error: getApiErrors(error) }))
  } finally {
    yield put(dismissRecommendationRoutine.fulfill({ signature }))
  }
}

function* executeEntityAction({ payload }) {
  const { entityType, entityId, ctaKind, payload: ctaPayload } = payload
  yield put(executeEntityActionRoutine.request({ entityType, entityId, ctaKind }))

  try {
    const { data } = yield call(guruChatService.executeEntityAction, { entityType, entityId, ctaKind, payload: ctaPayload || {} })
    const result = data.data || {}
    yield put(executeEntityActionRoutine.success({ entityType, entityId, ctaKind, result }))

    if (result.kind === 'chat_handoff' && result.question) {
      yield put(openWithEntity({
        entityAttachment: result.entityAttachment || result.entity_attachment || null,
        initialView: 'chat',
        prefilledInput: result.question,
      }))
    }
  } catch (error) {
    yield put(executeEntityActionRoutine.failure({ entityType, entityId, ctaKind, error: getApiErrors(error) }))
  } finally {
    yield put(executeEntityActionRoutine.fulfill({ entityType, entityId, ctaKind }))
  }
}

function* loadWatcher() {
  while (true) {
    const action = yield take(loadRecommendationsRoutine.TRIGGER)
    yield fork(loadRecommendations, action)
  }
}

function* dismissWatcher() {
  while (true) {
    const action = yield take(dismissRecommendationRoutine.TRIGGER)
    yield fork(dismissRecommendation, action)
  }
}

function* executeWatcher() {
  while (true) {
    const action = yield take(executeEntityActionRoutine.TRIGGER)
    yield fork(executeEntityAction, action)
  }
}

export function* guruRecommendationsSaga() {
  yield fork(loadWatcher)
  yield fork(dismissWatcher)
  yield fork(executeWatcher)
}
